import { theme as antdTheme, type ThemeConfig } from 'antd';

/**
 * Token màu lấy từ :root của SeriEvo-Accounting-Pitch-v2.html.
 * Thương hiệu: navy #20272E (thanh trên, tab/nút đang chọn), cam #F29F22 (điểm nhấn).
 * Giữ đồng bộ với biến CSS trong styles.css.
 */
export const palette = {
  brandOrange: '#F29F22',
  brandNavy: '#20272E',
  stage: '#E9EDF2',
  slide: '#FFFFFF',
  surface: '#F5F7FA',
  ink: '#1F2730',
  muted: '#5B6573',
  line: '#E2E6EC',
  blue: '#2563EB',
  blueSoft: '#EAF1FE',
  green: '#15803D',
  greenSoft: '#E7F6EC',
  red: '#DC2626',
  redSoft: '#FDECEC',
  amber: '#B45309',
  amberSoft: '#FEF3E2',
  violet: '#7C3AED',
  violetSoft: '#F1EBFE',
  teal: '#0E7C8C',
  tealSoft: '#E2F4F6',
  orange: '#C2690A',
  orangeSoft: '#FDEFD9',
} as const;

/** Màu theo ý nghĩa: dùng thống nhất ở KPI, tag, biểu đồ. */
export const semantic = {
  /** Doanh thu, hóa đơn đầu ra */
  revenue: { c: palette.blue, cs: palette.blueSoft },
  /** Khớp, tiền về */
  matched: { c: palette.green, cs: palette.greenSoft },
  /** Phí, lỗi */
  fee: { c: palette.red, cs: palette.redSoft },
  /** Thời gian, cảnh báo */
  time: { c: palette.amber, cs: palette.amberSoft },
  /** Thuế, pháp lý */
  tax: { c: palette.violet, cs: palette.violetSoft },
  /** Nguồn dữ liệu */
  source: { c: palette.teal, cs: palette.tealSoft },
  /** Thương hiệu */
  brand: { c: palette.orange, cs: palette.orangeSoft },
} as const;
export type Semantic = keyof typeof semantic;

export const platformColor = {
  shopee: { c: '#EE4D2D', cs: '#FDECE8' },
  tiktok: { c: '#161823', cs: '#ECEDEF' },
} as const;

export const fontFamily = '"Be Vietnam Pro", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export const appTheme: ThemeConfig = {
  algorithm: [antdTheme.defaultAlgorithm, antdTheme.compactAlgorithm],
  cssVar: true,
  hashed: false,
  token: {
    colorPrimary: palette.brandNavy,
    colorInfo: palette.blue,
    colorSuccess: palette.green,
    colorWarning: palette.amber,
    colorError: palette.red,
    colorLink: palette.blue,
    colorText: palette.ink,
    colorTextSecondary: palette.muted,
    colorBorder: palette.line,
    colorBorderSecondary: palette.line,
    colorBgLayout: palette.surface,
    colorBgContainer: palette.slide,
    fontFamily,
    fontSize: 13,
    borderRadius: 6,
    controlOutline: 'rgba(242, 159, 34, 0.25)',
  },
  components: {
    Layout: { headerBg: palette.brandNavy, headerHeight: 48, headerPadding: '0 16px', bodyBg: palette.surface },
    Segmented: { itemSelectedBg: palette.brandNavy, itemSelectedColor: '#FFFFFF' },
    Tabs: { inkBarColor: palette.brandNavy, itemSelectedColor: palette.brandNavy, itemActiveColor: palette.brandNavy },
    Table: { headerBg: palette.surface, headerColor: palette.muted, rowHoverBg: '#F0F3F7' },
    Card: { headerFontSize: 14 },
    Statistic: { contentFontSize: 22 },
  },
};
